export enum SprintPlanningExecutionMatchStatus {
  MATCHED = 'matched',
  UNMATCHED = 'unmatched',
}
